'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = (theme, utteranceLength) => ({
  tilesContainer: {
    textAlign: 'center',
    margin: '0 auto',
    p: '3.75rem 6.25rem 2.5rem 6.25rem',
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
    [theme.breakpoints.between('md', 'lg')]: {
      p: '3.75rem 2rem 2.5rem 2rem',
    },
  },
  utteranceList: {
    p: 0,
    [theme.breakpoints.down('sm')]: {
      p: '2rem 0',
    },
  },
  utteranceTiles: {
    flexGrow: 2,
  },
  singleUtterance: {
    width: '100%',
  },
  serviceTitle: {
    color: theme?.palette?.textHeading,
    [theme.breakpoints.down('sm')]: {
      pb: '1rem',
    },
  },
  serviceSubTitle: {
    color: theme?.palette?.textHeading,
    maxWidth: '56.25rem',
    margin: '1rem auto 1rem auto',
    [theme.breakpoints.down('sm')]: {
      margin: '0 1.5rem 2.5rem 1.5rem',
    },
  },
  tile: {
    p: '1rem 2.6rem 1.5rem 2.4rem',
    m: 2,
    display: 'flex',
    borderRadius: '0.375rem',
    boxShadow: theme?.palette?.boxShadow,
    cursor: 'pointer',
    minHeight: '7.5rem',
    height: 'auto',
    width: utteranceLength === 1 ? '100%' : 'inherit',
    color: theme?.palette?.button?.contained?.textColor,
    background: theme?.palette?.button?.contained?.background,
    '&:hover': {
      background: theme?.palette?.button?.contained?.backgroundHover,
      color: theme?.palette?.button?.contained?.textHoverColor,
    },
    '&:focus': {
      background: theme?.palette?.button?.contained?.backgroundHover,
      color: theme?.palette?.button?.contained?.textHoverColor,
    },
    [theme.breakpoints.down('sm')]: {
      p: '1rem 0.75rem',
      m: '0 1rem 1rem 1rem',
      height: 'auto',
      width: 'auto',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      p: 2,
    },
  },

  utteranceTexts: {
    textAlign: 'left',
    display: 'flex',
    maxWidth: '14.625rem',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '0 12px 0 12px',
    },
  },
});
